const CPF_MASK = "###.###.###-##";

export const cleanCpf = (cpf: string): string =>
  cpf.replace(/\D/g, "").slice(0, 11);

export const formatCpf = (value: string): string => {
  const v = cleanCpf(value);

  if (!v) return "";

  let i = 0;

  return (
    CPF_MASK.replace(/#/g, () => v[i++] ?? "")
      // remove tudo a partir do primeiro separador inválido
      .replace(/(\.|-)(?=[^0-9]|$)/g, "")
      // remove separadores no final
      .replace(/[.-]+$/g, "")
  );
};

export function performCPFMask(cpf: string): string {
  cpf = cpf.replace(/\D/g, "");
  cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
  cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
  cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  return cpf;
}
